export enum TurbineEnum {
    'E-70 E4' = 'E-70 E4',
    'E-82 E2' = 'E-82 E2',
    'E-82 E4' = 'E-82 E4',
    'E-115 E3' = 'E-115 E3',
    'E-115 E4' = 'E-115 E4',
    'E-138 E2' = 'E-138 E2',
    'E-138 E3' = 'E-138 E3',
    'E-160 E2' = 'E-160 E2',
    'E-160 E3' = 'E-160 E3',
    'E-175' = 'E-175',
    'V90' = 'V90',
    'V100' = 'V100',
    'V110' = 'V110',
    'V120' = 'V120',
    'V105' = 'V105',
    'V105 BWC' = 'V105 BWC',
    'V112' = 'V112',
    'V112 BWC' = 'V112 BWC',
    'V117' = 'V117',
    'V117 BWC' = 'V117 BWC',
    'V117-Typhoon' = 'V117-Typhoon',
    'V126' = 'V126',
    'V136' = 'V136',
    'V150' = 'V150',
    'V155' = 'V155',
    'V163' = 'V163',
    'V166' = 'V166',
    'V162' = 'V162',
    'V172' = 'V172',
    'N117' = 'N117',
    'N131' = 'N131',
    'N133' = 'N133',
    'N149' = 'N149',
    'N155' = 'N155',
    'N163' = 'N163',
    'N175' = 'N175',
    'SG 2.9-129' = 'SG 2.9-129',
    'SWT-DD-120' = 'SWT-DD-120',
    'SWT-DD-130' = 'SWT-DD-130',
    'SG 3.4-132' = 'SG 3.4-132',
    'SG 3.4-145' = 'SG 3.4-145',
    'SG 5.0-132' = 'SG 5.0-132',
    'SG 5.0-145' = 'SG 5.0-145',
    'SG 4.7-155' = 'SG 4.7-155',
    'SG 6.6-155' = 'SG 6.6-155',
    'SG 6.6-170' = 'SG 6.6-170',
    'SG 7.0-170' = 'SG 7.0-170',
    'Vensys 62' = 'Vensys 62',
    'Vensys 70' = 'Vensys 70',
    'Vensys 82' = 'Vensys 82',
    'Vensys 115' = 'Vensys 115',
    'Vensys 126' = 'Vensys 126',
    'Vensys 136' = 'Vensys 136',
    'Vensys 155' = 'Vensys 155',
    'Vensys 170' = 'Vensys 170',
    'DW52' = 'DW52',
    'DW54' = 'DW54',
    'DW54X' = 'DW54X',
    'DW58' = 'DW58',
    'DW61' = 'DW61',
    'LTW42' = 'LTW42',
    'LTW80' = 'LTW80',
    'LTW86' = 'LTW86',
    'LTW90' = 'LTW90',
    'LTW101' = 'LTW101',
    'GW136' = 'GW136',
    'GW155' = 'GW155',
    'GW165' = 'GW165',
    'GW171' = 'GW171',
    'GW175' = 'GW175',
    'GW182' = 'GW182',
    'MySE3.0-135' = 'MySE3.0-135',
    'MySE4.0-156' = 'MySE4.0-156',
    'MySE5.0-166' = 'MySE5.0-166',
    'MySE6.25-172' = 'MySE6.25-172',
    '' = ''
}